import Model from "./abstract/Model";

export default class Attachment extends Model {

  constructor(props) {
    super();

    this.initializeAttributes(props, {});
  }

  // No url getter: `url` arrives on the payload as an expiring URL from MediaUrl.
  // Building `API_URL + '/attachments/' + id` here instead does not work for
  // <img src> or <a href>, because a browser issued request carries no
  // Authorization header and that route sits behind auth:api.
}
